import { DatePickerSize } from './DatePicker.types';

type DatePickerConstsType = {
  [size in DatePickerSize]: {
    height: number;
    iconsHeight: number;
    clearIconTop: number;
    boxSize: number;
  };
};

export const datePickerConsts: DatePickerConstsType = {
  small: {
    height: 32,
    iconsHeight: 20,
    clearIconTop: 5,
    boxSize: 28,
  },
  medium: {
    height: 40,
    iconsHeight: 24,
    clearIconTop: 7,
    boxSize: 36,
  },
  large: {
    height: 48,
    iconsHeight: 24,
    clearIconTop: 11,
    boxSize: 44,
  },
};

export const arrowWidth = 12;
export const arrowHeight = 10;
export const arrowSize = '10px';
